import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { PassType } from "../models/PassType";
import {
	deletePassType,
	upsertPassType,
} from "../repositories/PassTypesRepository";
import { PASS_TYPES_QUERY_KEYS } from "./usePassTypes";

interface UsePassTypeMutationOptions {
	onSuccess?: (passType: PassType) => void;
	onError?: (error: Error) => void;
	onDeleteSuccess?: () => void;
}

export const usePassTypeMutation = ({
	onSuccess,
	onError,
	onDeleteSuccess,
}: UsePassTypeMutationOptions = {}) => {
	const queryClient = useQueryClient();

	const saveMutation = useMutation({
		mutationFn: upsertPassType,
		onSuccess: (passType) => {
			queryClient.invalidateQueries({ queryKey: PASS_TYPES_QUERY_KEYS.all });
			onSuccess?.(passType);
		},
		onError: (error: Error) => {
			onError?.(error);
		},
	});

	const deleteMutation = useMutation({
		mutationFn: deletePassType,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PASS_TYPES_QUERY_KEYS.all });
			onDeleteSuccess?.();
		},
		onError: (error: Error) => {
			onError?.(error);
		},
	});

	return {
		savePassType: saveMutation.mutate,
		deletePassType: deleteMutation.mutate,
		isSaving: saveMutation.isPending,
		isDeleting: deleteMutation.isPending,
	};
};
